document.addEventListener('DOMContentLoaded', function () {
    var definitionTerms = document.querySelectorAll('.especiality-dt');

    function closeAllItems() {
        definitionTerms.forEach(function (term) {
            term.classList.remove('open');
            if (term.nextElementSibling) {
                term.nextElementSibling.classList.remove('open');
            }
        });
    }

    definitionTerms.forEach(function (term) {
        term.addEventListener('click', function () {
            var details = this.nextElementSibling;
            var isOpen = this.classList.contains('open');

            closeAllItems();

            if (!isOpen && details) {
                this.classList.add('open');
                details.classList.add('open');
            }
        });
    });

    if (definitionTerms.length > 0 && definitionTerms[0].nextElementSibling) {
        definitionTerms[0].classList.add('open');
        definitionTerms[0].nextElementSibling.classList.add('open');
    }
});
